module.exports = __webpack_public_path__ + "img/ico-haimurubushi.f97375d6.png";